/**
 * @description Utility function to check if the unified goal setting feature is enabled.
 */
export function isUnifiedGoalSettingEnabled() {
  // Temporarily hardcoding this to true so we can end the UGS rollout experiment that was needed for the 2024 global holdout.
  // Logged a ticket to delete all the now-unused code to complete the cleanup: https://coursera.atlassian.net/browse/LRNRSCCSS-3616
  return true;
}
